import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { fontWeight } from "@mui/system";
import { IDarkTheme } from "styles/darkTheme";

const styles = makeStyles((theme: IDarkTheme) =>
  createStyles({
    featureTitle: {
      fontWeight: theme.fontWeight.big,
      fontSize: "32px",
      color: theme.colors.neutrals.neturals_100,
      lineHeight: "56px",
      "@media (max-width: 899px)": {
        fontWeight: theme.fontWeight.bold,
        color: "#4F48F0"
      }
    },
    trusedByTitle: {
      padding: "0 12px",
      fontWeight: theme.fontWeight.medium,
      fontSize: "18px",
      color: theme.colors.secondary.secondary_45,
      lineHeight: theme.lineHeight.normal,
      "@media (max-width: 899px)": {
        fontSize: "16px"
      }
    },
    trustedByListContainer: {
      position: "relative",
      display: "flex",
      alignItems: "center",
      width: "100%",
      overflow: "hidden"
    },
    trustedByAnimatedWrapper: {
      display: "flex",
      alignItems: "center",
      gap: "40px",
      animation: "$scrollLeft 30s linear infinite",
      "&:hover": {
        animationPlayState: "paused"
      },
      "& img": {
        height: "auto",
        width: "120px",
        "@media (max-width: 960px)": {
          width: "80px"
        },
        "@media (max-width: 600px)": {
          width: "60px"
        }
      },
      "@media (max-width: 960px)": {
        gap: "30px"
      },
      "@media (max-width: 600px)": {
        gap: "20px"
      }
    },
    "@keyframes scrollLeft": {
      "0%": {
        transform: "translateX(0)"
      },
      "100%": {
        transform: "translateX(-50%)"
      }
    },
    fadeLeft: {
      position: "absolute",
      top: 0,
      left: 0,
      height: "100%",
      background: "linear-gradient(to right, #F0F0F0, #FFFFFF00)",
      pointerEvents: "none",
      zIndex: 10
    },
    fadeRight: {
      position: "absolute",
      top: 0,
      right: 0,
      height: "100%",
      background: "linear-gradient(to left, #F0F0F0, #FFFFFF00)",
      pointerEvents: "none",
      zIndex: 10
    },
    featuresSectionDescription: {
      fontWeight: theme.fontWeight.normal,
      fontSize: theme.fontSize.heading_5,
      lineHeight: theme.fontSize.heading_5,
      color: theme.colors.neutrals.neutrals_80,
      "@media (max-width: 899px)": {
        fontSize: "16px",
        fontWeight: theme.fontWeight.medium
      }
    },
    featureDescription: {
      fontWeight: theme.fontWeight.normal,
      fontSize: theme.fontSize.heading_9,
      color: theme.colors.neutrals.neutrals_80,
      "@media (max-width: 899px)": {
        color: "#E3E2FD",
        textAlign: "center",
        paddingTop: "12px",
        fontSize: "16px",
        maxWidth: "345px"
      }
    },
    postCardText: {
      fontSize: "15px",
      lineHeight: "24px",
      fontFamily: theme.fontFamily.montserrat,
      color: theme.colors.neutrals.neturals_100,
      fontWeight: theme.fontWeight.medium
    },
    saveYour: {
      fontFamily: theme.fontFamily.montserrat,
      fontSize: theme.fontSize.heading_1,
      fontWeight: theme.fontWeight.bold,
      color: theme.colors.neutrals.neturals_100,
      "@media (max-width: 899px)": {
        color: theme.colors.semantic.semantic_white,
        fontSize: "32px"
      }
    },
    moneyNow: {
      fontFamily: theme.fontFamily.montserrat,
      fontSize: theme.fontSize.heading_1,
      fontWeight: theme.fontWeight.big,
      color: theme.colors.secondary.secondary_50,
      "@media (max-width: 899px)": {
        fontWeight: theme.fontWeight.bold,
        color: "#FFEE59",
        fontSize: "48px"
      }
    },
    lightBtn: {
      color: theme.colors.semantic.semantic_white,
      backgroundColor: theme.colors.secondary.secondary_50,
      textTransform: "none",
      padding: "8px 12px",
      borderRadius: "10px",
      marginTop: "auto",
      alignSelf: "center",
      fontWeight: theme.fontWeight.bold,
      fontSize: theme.fontSize.bodyText_1,
      "&:hover": {
        backgroundColor: theme.colors.secondary.secondary_50
      },
      "@media (max-width: 899px)": {
        border: "1px solid white"
      }
    },
    darkBtn: {
      color: theme.colors.secondary.secondary_50,
      backgroundColor: theme.colors.semantic.semantic_white,
      textTransform: "none",
      padding: "20px 55px",
      borderRadius: "8px",
      marginTop: "auto",
      alignSelf: "center",
      "&:hover": {
        backgroundColor: theme.colors.semantic.semantic_white
      }
    },
    sliderStyled: {
      "& .slick-dots li": {
        scale: "1.8"
      },
      "& .slick-dots li button:before": {
        opacity: 1,
        color: "white"
      },
      "& .slick-dots li button:hover:before": {
        opacity: 0.5,
        color: theme.colors.neutrals.neturals_70
      },
      "& .slick-dots .slick-active button:before": {
        color: theme.colors.neutrals.neutrals_70
      }
    },
    rightSideStar: {
      position: "absolute",
      right: "-24px",
      top: "-24px"
    },
    leftSideStar: {
      position: "absolute",
      left: "-24px",
      bottom: "-24px"
    },
    price: {
      textDecoration: "underline"
    },
    heroImg: {
      display: "block",
      maxWidth: "70%",
      height: "auto",
      "@media (max-width: 900px)": {
        display: "none"
      }
    },
    heroImgMobile: {
      display: "none",
      paddingTop: "12px",
      width: "100%",
      height: "auto",
      "@media (max-width: 899px)": {
        display: "block"
      }
    },
    starsLeft: {
      position: "absolute",
      left: 0,
      marginTop: "-200px",
      "@media (max-width: 899px)": {
        marginTop: "-80px",
        width: "100px"
      }
    },
    starsRight: {
      position: "absolute",
      right: 0,
      "@media (max-width: 899px)": {
        width: "100px",
        marginTop: "100px"
      }
    },
    footerLink: {
      color: theme.colors.secondary.secondary_50,
      fontFamily: theme.fontFamily.montserrat,
      fontWeight: theme.fontWeight.big,
      fontSize: theme.fontSize.bodyText_1,
      textDecoration: "none",
      padding: "8px 16px"
    },
    footerLogo: {
      "@media (max-width: 600px)": {
        width: "100px"
      }
    }
  })
);

export default styles;
